<template>
  <div class="recommend-wrap">
    <div class="recommend-card">
      <div class="top-wrap">
        <div class="title">你的邀请很值钱，快去邀请好友吧！</div>
        <!-- <div class="content">身边好友同为科研人？当他们注册后下单，您可获得8%奖励，好友可得：200元新人券 <i>了解详情 ＞</i></div> -->
        <img :src="register.invite_cover" class="recommend-img" alt="">
      </div>
      <div class="middle-wrap" v-loading="loading">
        <div class="inviter flex-row flex-y-center">
          <div class="title">我的邀请人：</div>
          <template v-if="user.inviter_id">
            <div class="title">{{ user.inviter_name }}</div>
          </template>
          <template v-else>
            <el-input class="mgl10" type="text" size="mini" style="width: 150px" v-model="form.alias" placeholder="邀请码">
            </el-input>
            <el-button size="mini" class="btn mgl10" @click="bindInviter">确定</el-button>
          </template>
        </div>
        <div class="title">邀请返利</div>
        <div class="content">1. 邀请方式一：分享您的专属邀请图，好友长按图片—识别图中二维码—注册；</div>
        <div class="view-btn flex-cc" @click="handleShowFxcard">查看</div>
        <div class="content">2.邀请方式二：将您的专属邀请链接发送给您的好友；</div>
        <div class="copy-info">
          <div class="copy-link">{{ user.invite_url }}</div>
          <div class="copy-btn" v-clipboard:copy="user.invite_url" v-clipboard:success="clipboardSuccess">复制链接</div>
        </div>
        <div class="content">3.邀请方式三：微信小程序搜索“元素魔方”，通过“个人>推广领现金”分享给您的好友。</div>
      </div>
      <div class="activity-rule">
        <div class="title">活动规则</div>
        <div class="content" v-html="page.content">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getIndex, bindInviter } from "@/api/user";
import { getConfig } from "@/api/common";
import { getPageDetail } from "@/api/page";
import waves from '@/directive/waves' // 水波纹指令
import clipboard from '@/directive/clipboard' // 复制指令
export default {
  name: 'UserRecommend',
  components: {

  },
  directives: {
    waves,
    clipboard
  },
  data() {
    return {
      loading: true,
      user: {
        invite_url: ''
      },
      fxcard: '',
      page: {},
      register: {},
      form: {
        alias: ''
      }
    };
  },
  computed: {

  },
  created() {
    this.getConfig();
    this.getPageDetail();
    this.getIndex();
  },
  methods: {
    getConfig() {
      getConfig({ group: 'register' }).then((res) => {
        this.register = res.data
      }).catch((err) => {
        console.log(err);
      })
    },
    getPageDetail() {
      getPageDetail({ alias: 'activity' }).then(res => {
        this.loading = false;
        this.page = res.data;
      }).catch((err) => {

      });
    },
    getIndex() {
      getIndex({}).then(res => {
        this.loading = false;
        this.user = res.data.user;
      }).catch((err) => {

      });
    },
    bindInviter() {
      const _form = Object.assign({}, this.form);
      if (!_form.alias) {
        this.$message.error('请输入邀请码')
        return false;
      }
      this.loading = true
      bindInviter(_form).then(res => {
        this.$message.success('操作成功'), setTimeout(() => {
          this.getIndex()
        }, 1000)

      }).catch((err) => {

      });
    },
    handleShowFxcard() {

    },
    clipboardSuccess() {
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.recommend-wrap {
  width: 100%;

  .recommend-card {
    width: 100%;
    margin-top: 16px;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 1px rgba(111, 127, 132, 0.102);
    border-radius: 2px;

    .title {
      font-size: 16px;
      font-weight: bold;
      color: #00B4E8;
      margin-bottom: 20px;
    }

    .top-wrap {
      width: 100%;
      padding: 33px 25px 50px 25px;
      box-sizing: border-box;
      border-bottom: 1px solid #CCD7DB;

      .content {
        font-size: 16px;
        font-weight: 300;
        color: #222222;

        i {
          font-size: 16px;
          font-weight: 400;
          color: #00B4E8;
          margin-left: 10px;
          cursor: pointer;
        }
      }

      .recommend-img {
        width: 100%;
        margin-top: 20px;
      }
    }

    .middle-wrap {
      width: 100%;
      padding: 25px;
      box-sizing: border-box;
      font-size: 16px;
      font-weight: 300;
      color: #222222;
      border-bottom: 1px solid #CCD7DB;

      .inviter {
        margin-bottom: 20px;

        .title {
          margin-bottom: 0;
        }

        .btn {
          background: #00B4E8;
          color: #FFF;
          border: none;
        }
      }

      .view-btn {
        width: 130px;
        height: 37px;
        background: #00b6e81e;
        border-radius: 19px;
        font-size: 16px;
        font-weight: 400;
        color: #00B4E8;
        margin-top: 12px;
        margin-left: 18px;
        margin-bottom: 10px;
        cursor: pointer;
      }

      .copy-info {
        display: flex;
        align-items: center;
        column-gap: 23px;
        margin: 10px 0 10px 18px;

        .copy-link {
          padding: 7px 25px;
          background: #00b6e81e;
          font-size: 16px;
          font-weight: 400;
          color: #00B4E8;
        }

        .copy-btn {
          padding: 7px 33px;
          background: #00b6e81e;
          font-size: 16px;
          font-weight: 400;
          color: #00B4E8;
          cursor: pointer;
        }
      }
    }

    .activity-rule {
      width: 100%;
      padding: 50px 25px;
      box-sizing: border-box;
      font-size: 16px;
      font-weight: 300;
      color: #222222;

      .content {
        font-size: 16px;
        font-weight: 300;
        color: #222222;
        line-height: 28px;
      }
    }
  }
}
</style>
